<template>

    <!-- EXISTING ELEMENT -->
    <div @contextmenu.prevent="pageContextMenu($event, pageElement, pageNumber, index)" v-if="pageElement != null" :class="['pageElementType-'+pageElement.contentElement.type.name, 'status-'+pageElement.status.name, 'inner']">

        <!-- DETAILED VIEW -->
        <template v-if="viewType == 'detailed'">

            <!-- User "Redaktion" is not allowed to use the drag&drop handler -->
            <template v-if="userRole != 'Redaktion'">
                <div class="drag-handle" title="verschieben">
                    <i class="fa fa-reorder"></i>
                    <!-- ≡ -->
                </div>
            </template>

            <template v-if="pageElement.contentElement.contentElementData && pageElement.contentElement.contentElementData.length > 0">

                <!-- RICH TEXT -->
                <template v-if="pageElement.contentElement.type.id == contentElementTypes.RICH_TEXT.id">
                    <content-rich-text :data="pageElement" :settings="{width: 100}"></content-rich-text>
                </template>

                <!-- PRODUCT PLACEMENT -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.PRODUCT.id">
                    <content-product :data="pageElement.contentElement.contentElementData[0].product" :settings="{width: 100}"></content-product>
                </template>

                <!-- ADVICE -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.ADVICE.id">
                    <content-advice :data="pageElement.contentElement.contentElementData" :settings="{width: 100}"></content-advice>
                </template>

                <!-- EXPERT ADVICE -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.EXPERT_ADVICE.id">
                    <content-expert-advice :data="pageElement" :settings="{width: 100}"></content-expert-advice>
                </template>

                <!-- APOPEDIA -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.APOPEDIA.id">
                    <content-apopedia :data="pageElement" :settings="{width: 100}"></content-apopedia>
                </template>

                <!-- RECIPE -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.RECIPE.id">
                    <content-recipe :data="pageElement" :settings="{width: 100}"></content-recipe>
                </template>

                <!-- PUZZLE -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.PUZZLE.id">
                    <content-puzzle :data="pageElement" :settings="{width: 100}"></content-puzzle>
                </template>

                <!-- NEU AM MARKT -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.NEU_AM_MARKT.id">
                    <content-product displayType="NEU_AM_MARKT" :data="pageElement.contentElement.contentElementData[0].product" :settings="{width: 100}"></content-product>
                </template>

                <!-- HAUSAPOTHEKE -->
                <template v-else-if="pageElement.contentElement.type.id == contentElementTypes.HAUSAPOTHEKE.id">
                    <content-product displayType="HAUSAPOTHEKE" :data="pageElement.contentElement.contentElementData[0].product" :settings="{width: 100}"></content-product>
                </template>

            </template>


            <!-- EMPTY ELEMENT - SHOW TYPE ICON -->
            <template v-else>

                <div class="pageElementTypeWrapper">

                    <div class="inner">

                        <div class="icon is-large">
                            <i :class="getPageElementType"></i>
                        </div>

                        <div class="text">{{ getPageElementName }}</div>

                    </div>

                </div>

            </template>


        </template>


        <!-- OVERVIEW VIEW-->
        <template v-else-if="viewType=='default'">

            <div class="statusCircle" :class="pageElement.status.name">
                <span></span>
            </div>

        </template>

        <!-- OTHER VIEWS ? -->
        <template v-else>

            <div class="statusCircle" :class="pageElement.status.name">
                <span></span>
            </div>

        </template>

    </div>

    <!-- NEW Element -->
    <div v-else class="inner" @contextmenu.prevent="pageContextMenu($event, null, pageNumber, index)">

    </div>


</template>

<script>
import contentProduct from './contentElements/contentElementProductPlacement';
import contentApopedia from './contentElements/contentElementApopedia';
import contentAdvice from './contentElements/contentElementAdvice';
import contentExpertAdvice from './contentElements/contentElementExpertAdvice';
import contentPuzzle from './contentElements/contentElementPuzzle';
import contentRecipe from './contentElements/contentElementRecipe';
import contentRichText from './contentElements/contentElementRichText';

export default {

    props: ['pageElement', 'pageNumber', 'index', 'viewType'],

    data() {
		return {

		}
	},

    components: {
        contentProduct,
        contentPuzzle,
        contentRecipe,
        contentRichText,
        contentApopedia,
        contentAdvice,
        contentExpertAdvice
    },

    computed: {

        contentElementTypes() {
            return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');
        },

        getPageElementType() {

            switch(this.pageElement.contentElement.type.name)
            {
                case "RICH_TEXT": return "icon-ak-inhalte";
                case "PRODUCT":
                case "HAUSAPOTHEKE":
                case "NEU_AM_MARKT":
                  return "icon-ak-placement";
                case "ADVICE": return "icon-ak-tipp";
                case "EXPERT_ADVICE": return "icon-ak-profitipp";
                case "APOPEDIA": return "icon-ak-apopedia";
                case "RECIPE": return "icon-ak-rezept";
                case "PUZZLE": return "";
                default: return '';
            }

            return '';
        },

        getPageElementName() {

            for(var key in this.contentElementTypes) {
                if(this.contentElementTypes[key].id == this.pageElement.contentElement.type.id) {
                    return this.$t('PLACEMENT_TYPE-'+this.contentElementTypes[key].name);
                }
            }
        }

    },

    mounted() {

    },

    methods: {

        pageContextMenu(evt, pageElement, pageNumber, index) {

            if(this.viewType=='detailed') {
                this.$emit('pageContextMenu', [evt, pageElement, pageNumber, index]);
            }
        }

    }

}

</script>

<style scoped>

    .drag-handle {
    	position: absolute;
        z-index: 99;
    	right: 0;
    	top:12px;
    	width:24px;
    	height: 24px;
        display: block;
    	text-align: center;
    	cursor: move;
        cursor: -webkit-grabbing;
        color: #222 !important;
        font-size: 24px;
        line-height: 24px;
        opacity: 0;
        transition: opacity .3s ease;
    }
    .contentPageElement:hover .drag-handle {
        opacity: 1;
    }

</style>


<style>

    .contentPageElement:hover .pageElementTypeWrapper .inner {
        opacity: 1;
    }

    .pageElementTypeWrapper {
        position: relative;
        z-index: 1;
        width: 5.5vw;
        height: 5vw;
        top: 33%;
        margin: 0 auto;
        border-radius: 3px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pageElementTypeWrapper .inner {
        z-index: 2;
        opacity: 0.3;
        transition: opacity .3s ease;
    }

    .pageElementTypeWrapper .icon {
        z-index: 2;
        position: relative;
    }

    .pageElementTypeWrapper .text {
        display: block;
        margin: 1% auto 0 auto;
        line-height: 1em;
        text-align: center;
        font-size: 50%;
        text-transform: uppercase;
    }

    /* is-6 column */
    .rectangle-content .is-6 .contentWrapper {
        font-size: 65% !important;
    }
    .rectangle-content .is-6 .prop-inner {
        padding: 3% 2% 2% 2% !important;
    }
    .rectangle-content .is-6 .legalInformation {
        padding: 2% !important;
    }

    /* is-4 column */
    .rectangle-content .is-4 .contentWrapper {
        font-size: 70% !important;
    }
    .rectangle-content .is-4 .prop-inner {
        padding: 4% !important;
    }
    .rectangle-content .is-4 .legalInformation {
        padding: 4% !important;
    }

    /* is-2 column */
    .rectangle-content .is-2 .contentWrapper {
        font-size: 55% !important;
    }
    .rectangle-content .is-2 .prop-inner {
        padding: 10% 6% 6% 6% !important;
    }
    .rectangle-content .is-2 .legalInformation {
        padding: 6% !important;
    }

</style>
